import request from '@/utils/request';

// 获取签约信息
export function getSignInfo() {
  return request({
    url: '/icbc/h5/cardlessPay/sign',
    method: 'get'
  });
}

// 获取短信验证码
export function verCode(data) {
  return request({
    url: '/icbc/h5/cardlessPay/Msg',
    method: 'post',
    data
  });
}

// 签约
export function sign(data) {
  return request({
    url: '/icbc/h5/cardlessPay/sign',
    method: 'post',
    data
  });
}

// 签约授权
export function signAuth(params) {
  return request({
    url: '/icbc/h5/cardlessPay/auth',
    method: 'post',
    params
  });
}

// 解约
export function terminateSign(signId) {
  return request({
    url: `/icbc/h5/cardlessPay/update?signId=${signId}`,
    method: 'post'
  });
}

// 免密支付
export function payFree(amount, userId) {
  return request({
    url: `/icbc/h5/cardlessPay/pay?amount=${Math.round(
      amount * 100
    )}&userId=${userId}`,
    method: 'post'
  });
}
